import './AllFilesTree.css';

import React from 'react';
import Button from '../../../common/Button';
import t from '../../../i18n/I18n';
import Store from '../../../store/Store';
import StoreListener from '../../../store/StoreListener';
import {
  ALL_FILES_OPTION,
  SHOW_SPOTLIGHT_FILES,
  SPOTLIGHT_CONTENT,
  SHOW_FOLDERNAV_VIEW,
  BREADCRUMB_ASSETS,
  ASSETS_TAB_ARGS,
  GLOBAL_SEARCH_INFO
} from '../../../store/Constants';
import ViewUtil from '../../../ViewUtil';
import SpotlightUtil from '../../../queries/spotlight/SpotlightUtil';
import { ThemeSetup } from '../../../themes/ThemeSetup';
import { SetterStoreUtil } from '../../../store/setterStoreUtil';


type Props = {};

type State = {
  selectedOption: boolean
};

export default class AllFilesTree extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const option = Store.get(ALL_FILES_OPTION);
    this.state = {
      selectedOption: option
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.selectedOption != Store.get(ALL_FILES_OPTION)) {
      const selectedOption = Store.get(ALL_FILES_OPTION);
      this.setState({ selectedOption });
    }
  }

  onClick(e: MouseEvent, selectedOption: AllFilesOption) {
    e.stopPropagation();
    window.gs.blockSearch = false;
    const callBackFunction = selectedOption == SHOW_SPOTLIGHT_FILES ? this.showSpotLightFiles : this.showAllFiles;
    this.setState({ selectedOption }, callBackFunction);
  }

  showAllFiles = () => {
    SetterStoreUtil.deactivateGlobalSearch();
    SetterStoreUtil.setAllFilesOption(true);
    ViewUtil.setPwd(null);
    Store.put(BREADCRUMB_ASSETS, []);
    this.removeOtherActiveNode();
  };

  showSpotLightFiles = () => {
    SetterStoreUtil.setAllFilesOption(SHOW_SPOTLIGHT_FILES)
    ViewUtil.setPwd(null);
    this.removeOtherActiveNode();
  };

  removeOtherActiveNode() {
    const element = document.getElementsByName('TreeView')[0].getElementsByClassName('active')[0];
    if (element) element.classList.remove('active');
  }

  render() {
    return (
      <div name="AllFilesTree" className={this.state.selectedOption ? 'active' : ''}>
        <div>
          <Button
            className={this.state.selectedOption ? 'active' : ''}
            icon={
              this.state.selectedOption
                ? ThemeSetup.getImageURL('all_files_active.svg')
                : ThemeSetup.getImageURL('all_files.svg')
            }
            style={{ paddingLeft: '5px', marginBottom: '20px' }}
            text={t('ALL_FILES')}
            onClick={this.showAllFiles}
          />
        </div>
        {/* <div>
          <Button
            icon={ThemeSetup.getImageURL('recent.svg')}
            style={{ paddingLeft: '5px' }}
            text="Recent"
            onClick={(e) => this.onClick(e, SHOW_ALL_FILES)}
          />
        </div> */}

        {/* <div>
          <Button
            className={this.state.selectedOption == SHOW_SPOTLIGHT_FILES ? 'active' : ''}
            style={{ paddingLeft: '5px' }}
            icon={
              this.state.selectedOption == SHOW_SPOTLIGHT_FILES
                ? 'images/spot_light_active.svg'
                : 'images/spot_light.svg'
            }
            text={t('SPOTLIGHT_SMALL')}
            onClick={(e) => this.onClick(e, SHOW_SPOTLIGHT_FILES)}
          />
        </div> */}
      </div>
    );
  }
}
